<template>
  <div>
    <div style="display:flex">
      <Upload
      ref="upload"
      :show-upload-list="false"
      :multiple="multiple"
      :format="['pdf']"
      accept=".pdf"
      action="/api/common/fileUploadResultFid"
      :headers="headers"
      :before-upload="handleBeforeUp">
        <Button icon="ios-cloud-upload-outline" type="primary">上传文件</Button>
      </Upload>
      <span v-if="!multiple" style="margin-left:15px;color:#999">{{!file?'请上传pdf格式的文件':file.name}}</span>
      <span v-else style="margin-left:15px;color:#999">
        <span v-if="!fileList.length">请上传pdf格式的文件</span>
        <div v-else>
          <p v-for="(i,index) in fileList" :key="i.name">{{i.name}} <Icon @click="delFile(index)" type="md-close-circle" /></p>
        </div>
      </span>
      <Button style="display:none" type="text" @click="upload">点击上传</Button>
    </div>
  </div>
</template>
<script>
import { fileUploadResultFid,uploadFile } from '@/api/api'
export default {
  name: 'UploadFile',
  props: {
    value: {
      type: [Number,Array],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    isRegister: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headers: {},
      file: null,
      fileList: []
    }
  },
  mounted () {
  },
  created () {
    this.headers['Authorization'] = sessionStorage.getItem('token') ? 'Bearer ' + sessionStorage.getItem('token') : ''
  },
  methods:{
    handleBeforeUp (file) {
      if(this.name&&file.name !== this.name+'.pdf'){
        this.$Notice.warning({
          title: '文件名不正确',
          desc: '需上传前缀为"'+this.name+' "的pdf格式文件'
        })
        return false
      }else if(file.type !== 'application/pdf'){
        this.$Notice.warning({
          title: '文件格式不正确',
          desc: '文件 ' + file.name + ' 格式不正确，请上传pdf格式的文件'
        })
        return false
      }else if(file.size/1024/1024>10){
        this.$Notice.warning({
          title: '文件大小超过限制',
          desc: '文件 ' + file.name + ' 大小不得超过10M'
        })
        return false
      }else {
        if(!this.multiple){
          this.file = file
          this.fileList[0] = file
          this.isRegister&&this.$emit('input',1)
          return false
        }else {
          this.fileList.push(file)
          this.$emit('input',this.fileList.length)
          return false
        }
      }
    },
    delFile (index) {
      this.fileList.splice(index,1)
      this.$emit('input',this.fileList.length)
    },
    upload () {
      const formData = new FormData()
      if(!this.isRegister) {
        formData.append('file',this.file)
        return fileUploadResultFid(formData).then(res => {
          this.$emit('input',res)
        }).catch(err => console.log(err))
      }else {
        this.fileList.forEach(i => {
          formData.append('files',i)
        })
        return uploadFile(formData)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
li {
  font-size: 14px;
  font-weight: 500;
  .ivu-icon {
    color: #1890FF;
    cursor: pointer;
    font-size: 20px;
    margin-left: 15px;
  }
}
</style>
